module.exports = __webpack_public_path__ + "static/media/enlarger_left.905526d1.jpg";